export type FetchStreamOptions = {
  onMessage: (data: string) => void;
};

export default async (url: string, options: RequestInit, { onMessage }: FetchStreamOptions) => {
  const response = await fetch(url, options);
  const reader = response.body?.pipeThrough(new TextDecoderStream()).getReader();
  while (true) {
    const read = await reader?.read();
    if (read?.done) {
      break;
    }
    if (read?.value !== undefined) {
      onMessage(read.value);
    }
  }
};
